import { SET_DEAL_VALIDATION } from '../actions/ActionTypes';
import { getDealValidationKey } from '../utils/dealValidation';
const initialState = {};
export default function dealValidation(state = initialState, action) {
  const {
    payload
  } = action;
  if (!payload) {
    return state;
  }
  switch (action.type) {
    case SET_DEAL_VALIDATION:
      return Object.assign({}, state, {
        [getDealValidationKey(payload.dealId, payload.propertyName)]: payload.validationState
      });
    default:
      return state;
  }
}